export default class Stats {
  workingHoursId!: number;
  totalPeople!: number;
  totalBookings!: number;
  totalCancellations!: number;
  timesList!: string[];
  peopleByTime!: number[];
  bookingsByTime!: number[];

  constructor(jsonObj?: Stats) {
    if (jsonObj) {
      this.workingHoursId = jsonObj.workingHoursId;
      this.totalPeople = jsonObj.totalPeople;
      this.totalBookings = jsonObj.totalBookings;
      this.totalCancellations = jsonObj.totalCancellations;
      this.timesList = jsonObj.timesList;
      this.peopleByTime = jsonObj.peopleByTime;
      this.bookingsByTime = jsonObj.bookingsByTime;
    }
  }
}
